import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=310b76b0&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310b76b0')) {
      api.createRecord('310b76b0', component.options)
    } else {
      api.reload('310b76b0', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=310b76b0&", function () {
      api.rerender('310b76b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lK1yRvwVK7PU/JS/offershelp.vue"
export default component.exports